<boi-declaration-content [declarationDto]="declarationDto"></boi-declaration-content>